import { Validators } from '@angular/forms'

export class PatternValidators {
    static readonly nonAlphabetical = Validators.pattern(/^[^A-Za-z]*$/)
}
